// ==========================================
// apiService.js (Corrected & Optimized with Salary/Reports Support)
// ==========================================
const BASE_URL = "/api/preschool";
//const BASE_URL = "http://localhost:9093/api/preschool";

const request = async (endpoint, options = {}) => {
  const token = sessionStorage.getItem("token"); 
  
  const headers = {
    ...(token && { "Authorization": `Bearer ${token}` }),
    ...options.headers,
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }

  const config = {
    ...options,
    headers,
  };

  const url = `${BASE_URL.replace(/\/$/, "")}/${endpoint.replace(/^\//, "")}`;

  const response = await fetch(url, config);

  if (response.status === 401) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("roleId");
    sessionStorage.removeItem("clientName");
    sessionStorage.removeItem("clientId");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("isBiometricRegistered");
    window.location.href = "/login";
    throw new Error("Session expired. Please log in again.");
  }

  // FIX: Read the body text once. If response is not ok, parse error text/JSON safely 
  // without triggering a "body stream already read" error.
  const text = await response.text();
  let data = {};
  
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { message: text };
  }

  if (!response.ok) {
    throw new Error(data.error || data.message || `HTTP error! status: ${response.status}`);
  }

  return data;
};

export const apiService = {
  // ── Authentication & Auth ──
  login: async (credentials) => {
    const response = await request("/auth/login", { 
      method: "POST", 
      body: JSON.stringify(credentials) 
    });

    if (response.token) {
      sessionStorage.setItem("token", response.token);
      sessionStorage.setItem("clientId", response.clientId);
      sessionStorage.setItem("userId", response.userId);
      sessionStorage.setItem("roleId", response.roleId);
      sessionStorage.setItem("clientName", response.clientName);
      sessionStorage.setItem("isBiometricRegistered", response.biometricRegistered ? "true" : "false");
    }

    return response;
  },

  logout: () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("roleId");
    sessionStorage.removeItem("clientName");
    sessionStorage.removeItem("clientId");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("isBiometricRegistered");
    window.location.href = "/login";
  },

  getCurrentUserToken: () => sessionStorage.getItem("token"),
  isAuthenticated: () => !!sessionStorage.getItem("token"),
  getBiometricStatus: () => sessionStorage.getItem("isBiometricRegistered") === "true",

  // ── Attendance Module ──
  attendance: {
    registerBiometric: async (payload) => {
      const result = await request("/attendance/register-biometric", {
        method: "POST",
        body: JSON.stringify(payload)
      });
      sessionStorage.setItem("isBiometricRegistered", "true");
      return result;
    },
    checkIn: (payload) => request("/attendance/check-in", {
      method: "POST",
      body: JSON.stringify(payload)
    }),
    checkOut: (payload) => request("/attendance/check-out", {
      method: "POST",
      body: JSON.stringify(payload)
    })
  },

  // ── Attendance Reports & Salary Calculations Module ──
  salaryAndReports: {
    getStudentMonthlyAttendance: (month) => 
      request(`/reports/monthly-attendance/students?month=${encodeURIComponent(month)}`, {
        method: "GET"
      }),
      
    getStaffMonthlyAttendance: (month) => 
      request(`/reports/monthly-attendance/staff?month=${encodeURIComponent(month)}`, {
        method: "GET"
      }),

    calculateSalary: (payload) => 
      request("/salary/calculate", {
        method: "POST",
        body: JSON.stringify(payload)
      })
  }
};